import Reveal from "./Reveal";

const chapters = [
  ["01", "Start with care", "Every pie is treated with the respect we would give to feeding our own family."],
  ["02", "Keep the kitchen honest", "The ingredients, the preparation, and the way the kitchen runs all answer to the neighborhood."],
  ["03", "Make regulars", "New customers become regulars because the commitment is felt from the first order."],
  ["04", "Move at the speed of hungry", "Order online for the best value, faster service, and a direct way to support local favorites."],
  ["05", "Show up for Mine Hill", "We are grateful to be part of the community and serve our neighbors every day."],
];

export default function Manifesto() {
  return (
    <section className="manifesto-section" id="manifesto" data-testid="manifesto-section-container">
      <div className="container">
        <Reveal className="manifesto-head"><div><span className="eyebrow">The house rules</span><h2 className="section-title">Five ways to treat a neighborhood right.</h2></div><p className="body-copy">The best pizza is not just a recipe. It is a promise made to the people who order it, share it, and come back for it.</p></Reveal>
        <div className="manifesto-grid">
          {chapters.map(([number, title, description]) => <Reveal key={number} className="manifesto-card"><div><span className="manifesto-number">{number}</span><h3>{title}</h3><p>{description}</p></div><span className="manifesto-badge">Fucino principle</span></Reveal>)}
        </div>
      </div>
    </section>
  );
}
